// UI components
import { ImandraUniverseLogo } from './logos/logo-universe-by-imandra'
import { ImandraXLogo } from './logos/logo-imandrax'
import { TextPreTitle } from './typography'

const hoverClasses =
  'rounded-full p-1 pr-3 opacity-80 transition-all duration-300 ease-out hover:bg-slate-200/90 hover:opacity-100 hover:ring-1 hover:ring-slate-300/60 dark:hover:bg-white/10 dark:hover:ring-white/15'

/**
 * `"full"` (default) — ImandraX + Imandra Universe. Use on sites that are
 * powered by ImandraX but are not imandrax.dev itself (e.g. codelogician.dev).
 *
 * `"universe"` — Imandra Universe only. Use on imandrax.dev where linking
 * back to imandrax.dev would be a self-link.
 */
export function PoweredBy({
  variant = 'full',
}: {
  variant?: 'full' | 'universe'
}) {
  return (
    <div className="mt-6 flex flex-row items-center gap-4 md:mt-0">
      <TextPreTitle colors="text-slate-900 dark:text-slate-300 font-thin ">
        Powered by:
      </TextPreTitle>

      {variant === 'full' && (
        <a
          href="https://imandrax.dev"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="ImandraX"
          className={hoverClasses}
        >
          <ImandraXLogo className="h-8 w-auto text-slate-900 dark:text-white" />
        </a>
      )}
      <a
        href="https://universe.imandra.ai"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Imandra Universe"
        className={hoverClasses}
      >
        <ImandraUniverseLogo className="h-8 w-auto text-slate-900 dark:text-white" />
      </a>
    </div>
  )
}
